export default {
  install (Vue) {
    Vue.prototype.$localize = function (key) {
      return this.$vuetify.lang.t('$vuetify.' + key)
    }
  },

  getViewer () {
    return document.getElementById('viewer')
  },

  deserializeBoolean (value) {
    return (value === 1 || value === '1' || value === 'true')
  },

  deserializeFloat (value) {
    return parseFloat(value)
  },

  convertHexaToRGB (hexa) {
    const rgbHex = hexa.match(/.{1,2}/g)
    const rgb = [
      parseInt(rgbHex[0], 16),
      parseInt(rgbHex[1], 16),
      parseInt(rgbHex[2], 16),
    ]
    return rgb
  },

  buildBackgroundShade (hexa) {
    const rgbArray = this.convertHexaToRGB(hexa)
    return { shadeTop: { r: rgbArray[0], g: rgbArray[1], b: rgbArray[2] }, shadeDown: { r: rgbArray[0], g: rgbArray[1], b: rgbArray[2] } }
  },
}
